import React from "react";
import {SideMenu, SideMenuItem, Text, styled, theme} from "@reside/ui";
import {UserDto} from "../../../utils/types/user";

const SSOMessage = styled.div`
  border: 1px solid ${theme.color.borderGray};
  border-radius: ${theme.space[1]}px;
  padding: ${theme.space[2]}px;
  margin-top: ${theme.space[2]}px;
`;

export const SidebarMenu = ({user}: {user: UserDto}) => {
  const menuOptions = [
    {
      slug: "profile",
      label: "User Details",
    },
  ];

  if (!user?.organization?.hasSsoConfig?.ssoIsEnabled) {
    menuOptions.push({
      slug: "change-password",
      label: "Change Password",
    });
  }

  return (
    <SideMenu>
      {menuOptions.map(({slug, label}) => (
        <SideMenuItem key={slug}>
          {({Link}) => (
            <Link to={`/admin/user/${user.id}/${slug}`}>{label}</Link>
          )}
        </SideMenuItem>
      ))}
      {user?.organization?.hasSsoConfig?.ssoIsEnabled && (
        <SSOMessage>
          <Text fontSize={2} color="gray100">
            Your organization is SSO enabled. To change any of your details, or
            to reset your password contact your IT administrator.
          </Text>
        </SSOMessage>
      )}
    </SideMenu>
  );
};
